import { render, staticRenderFns } from "./CreateInstagramChannel.vue?vue&type=template&id=160a7e33&scoped=true"
import script from "./CreateInstagramChannel.vue?vue&type=script&lang=js"
export * from "./CreateInstagramChannel.vue?vue&type=script&lang=js"
import style0 from "./CreateInstagramChannel.vue?vue&type=style&index=0&id=160a7e33&prod&lang=scss&scoped=true"
import style1 from "./CreateInstagramChannel.vue?vue&type=style&index=1&id=160a7e33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160a7e33",
  null
  
)

export default component.exports